<template>
  <modal :show="showModal" modal-classes="modal-secondary" size="lg">
    <edit-tax-group-component
      v-if="taxGroup"
      :taxGroupId="taxGroup.id"
      @onViewTaxGroup="openTaxGroupViewModal"
      only-taxes
      @cancelEdition="closeFormModal"
    />
  </modal>
</template>

<script>
import { cloneDeep } from "lodash";
import EditTaxGroupComponent from "../../components/EditTaxGroupComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    EditTaxGroupComponent,
  },
  props: ["taxGroupData", "showModal"],

  data() {
    let taxGroupData = { ...this.taxGroupData };
    return {
      taxGroup: taxGroupData,
    };
  },

  methods: {
    openTaxGroupViewModal() {
      this.$emit("needReload");
      this.closeFormModal();
    },
    closeFormModal() {
      this.$emit("onChangeModalState");
    },
  },

  watch: {
    taxGroupData(taxGroupData) {
      if (taxGroupData) {
        this.taxGroup = {
          ...this.taxGroup,
          ...cloneDeep(taxGroupData),
        };
      }
    },
  },
};
</script>
